import axios from 'axios';

import {
  ScriveAccountConfigurationModel,
  ArenaSignSignerRoleSearchModel,
  ArenaSignSignerRolesConfigurationModel,
  ArenaSignSignerRoleConfigurationModel,
  ArenaSignSignerRoleCreateUpdateModel,
  BaseResultModel,
  ArenaSignTemplatesSearchModel,
  ScriveTemplatesConfigurationModel,
  ArenaSignTemplateCreateUpdateModel,
  ArenaSignTemplateSearchModel,
  ScriveTemplateConfigurationModel,
  ArenaSignApi,
  ScriveTemplateSigningPartySearchModel,
  ScriveTemplateSigningPartyConfigurationModel,
  ScriveTemplateSigningPartyCreateUpdateModel,
  ScriveTemplateSigningPartyFieldSearchModel,
  ScriveTemplateSigningPartyFieldModel,
  ScriveTemplateSigningPartyFieldCreateUpdateModel,
  ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel,
  ScriveTemplateSigningPartyFieldPlacementSearchModel,
  ScriveTemplateSigningPartyFieldPlacementModel,
  ScriveSettingsModel,
  ArenaSignDocumentTypeUpdateModel,
  ArenaSignDocumentTypeConfigurationModel,
  ArenaSignDocumentTypeSearchModel,
  ArenaSignTemplateAfterSignSettingModel,
  ArenaSignTemplateAfterSignConfigurationModel,
  DocumentTypeModel,
  CabinetModel,
  ArenaSignTemplateAfterSignSettingUpdateModel
} from '@/types';

import AxiosConfiguration from '@/classes/AxiosConfiguration';
import { ScriveSettingsConfigurationModel } from '@/types';

const ConfigurationUrl = 'ScriveConfiguration/';

export const ScriveConfigurationService = {
  async getIsAuthenticationKeySet(): Promise<boolean> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ConfigurationUrl}IsAuthenticationKeySet`);
    return response.data;
  },
  async UpdateAccountConfigurationAsync(accountConfigurationModel: ScriveAccountConfigurationModel) {
    await axios.put(`${ConfigurationUrl}AuthenticationKey`, accountConfigurationModel);
  },
  async ClearAccountConfigurationAsync() {
    await axios.put(`${ConfigurationUrl}ClearAuthenticationKey`);
  },
  async getDocumentTypeConfigurationAsync(
    documentTypeSearchModel: ArenaSignDocumentTypeSearchModel
  ): Promise<ArenaSignDocumentTypeConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ConfigurationUrl}documentType/configuration`, {
      params: {
        documentTypeId: documentTypeSearchModel.documentTypeId
      }
    });
    return response.data;
  },
  async updateDocumentTypeAsync(
    arenaSignDocumentTypeUpdateModel: ArenaSignDocumentTypeUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.put(
      `${ConfigurationUrl}documentType/${arenaSignDocumentTypeUpdateModel.documentTypeId}`,
      arenaSignDocumentTypeUpdateModel
    );
    return response.data;
  },
  async getSignerRolesConfigurationAsync(
    ArenaSignSignerRoleSearchModel: ArenaSignSignerRoleSearchModel
  ): Promise<ArenaSignSignerRolesConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ConfigurationUrl}signerroles`, {
      params: {
        documentTypeId: ArenaSignSignerRoleSearchModel.documentTypeId
      }
    });
    return response.data;
  },
  async getSignerRoleConfigurationAsync(
    signerRoleSearchModel: ArenaSignSignerRoleSearchModel
  ): Promise<ArenaSignSignerRoleConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(
      `${ConfigurationUrl}${signerRoleSearchModel.documentTypeId}/signerRole`,
      {
        params: {
          documentTypeId: signerRoleSearchModel.documentTypeId,
          signerRoleId: signerRoleSearchModel.signerRoleId
        }
      }
    );
    return response.data;
  },
  async updateSignerRoleAsync(
    documentTypeId: number,
    signerRoleId: number,
    docuSignSignerRoleUpdateModel: ArenaSignSignerRoleCreateUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.put(
      `${ConfigurationUrl}${documentTypeId}/signerRole/${signerRoleId}`,
      docuSignSignerRoleUpdateModel
    );
    return response.data;
  },
  async createSignerRoleAsync(
    documentTypeId: number,
    docuSignSignerRoleUpdateModel: ArenaSignSignerRoleCreateUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.post(`${ConfigurationUrl}${documentTypeId}/signerRole`, docuSignSignerRoleUpdateModel);
    return response.data;
  },
  async deleteSignerRoleAsync(signerRoleId: number) {
    await axios.delete(`${ConfigurationUrl}signerRole/${signerRoleId}`);
  },
  async getTemplatesConfigurationAsync(
    templatesSearchModel: ArenaSignTemplatesSearchModel
  ): Promise<ScriveTemplatesConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ConfigurationUrl}templates/configuration`, {
      params: {
        documentTypeId: templatesSearchModel.documentTypeId
      }
    });
    return response.data;
  },
  async updateTemplateAsync(
    templateId: number,
    arenaSignTemplateUpdateModel: ArenaSignTemplateCreateUpdateModel
  ): Promise<BaseResultModel> {
    arenaSignTemplateUpdateModel.arenaSignApi = ArenaSignApi.Scrive;
    const response = await axios.put(`${ConfigurationUrl}template/${templateId}`, arenaSignTemplateUpdateModel);
    return response.data;
  },
  async getTemplateConfigurationAsync(
    templateSearchModel: ArenaSignTemplateSearchModel
  ): Promise<ScriveTemplateConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ConfigurationUrl}template/configuration`, {
      params: {
        documentTypeId: templateSearchModel.documentTypeId,
        templateId: templateSearchModel.templateId
      }
    });
    return response.data;
  },
  async createTemplateAsync(
    arenaSignTemplateUpdateModel: ArenaSignTemplateCreateUpdateModel
  ): Promise<BaseResultModel> {
    arenaSignTemplateUpdateModel.arenaSignApi = ArenaSignApi.Scrive;
    const response = await axios.post(`${ConfigurationUrl}template`, arenaSignTemplateUpdateModel);
    return response.data;
  },
  async deleteTemplateAsync(templateId: number) {
    await axios.delete(`${ConfigurationUrl}template/${templateId}`);
  },
  async getTemplateSigningPartyConfigurationAsync(
    templateSigningPartySearchModel: ScriveTemplateSigningPartySearchModel
  ): Promise<ScriveTemplateSigningPartyConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ConfigurationUrl}signingparty/configuration`, {
      params: {
        documentTypeId: templateSigningPartySearchModel.documentTypeId,
        templateSigningPartyId: templateSigningPartySearchModel.templateSigningPartyId
      }
    });
    return response.data;
  },
  async createSigningPartyAsync(
    scriveTemplateSigningPartyCreateUpdateModel: ScriveTemplateSigningPartyCreateUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.post(`${ConfigurationUrl}signingparty`, scriveTemplateSigningPartyCreateUpdateModel);
    return response.data;
  },
  async updateSigningPartyAsync(
    signingPartyId: number,
    scriveTemplateSigningPartyCreateUpdateModel: ScriveTemplateSigningPartyCreateUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.put(
      `${ConfigurationUrl}signingparty/${signingPartyId}`,
      scriveTemplateSigningPartyCreateUpdateModel
    );
    return response.data;
  },
  async deleteSigningPartyAsync(signingPartyId: number) {
    await axios.delete(`${ConfigurationUrl}signingparty/${signingPartyId}`);
  },
  async getTemplateSigningPartyFieldConfigurationAsync(
    templateSigningPartyFieldSearchModel: ScriveTemplateSigningPartyFieldSearchModel
  ): Promise<ScriveTemplateSigningPartyFieldModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(
      `${ConfigurationUrl}signingpartyfield/configuration`,
      {
        params: {
          templateSigningPartyFieldId: templateSigningPartyFieldSearchModel.templateSigningPartyFieldId
        }
      }
    );
    return response.data;
  },
  async createSigningPartyFieldAsync(
    templateSigningPartyFieldCreateUpdateModel: ScriveTemplateSigningPartyFieldCreateUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.post(
      `${ConfigurationUrl}signingpartyfield`,
      templateSigningPartyFieldCreateUpdateModel
    );
    return response.data;
  },
  async updateSigningPartyFieldAsync(
    signingPartyFieldId: number,
    templateSigningPartyFieldCreateUpdateModel: ScriveTemplateSigningPartyFieldCreateUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.put(
      `${ConfigurationUrl}signingpartyfield/${signingPartyFieldId}`,
      templateSigningPartyFieldCreateUpdateModel
    );
    return response.data;
  },
  async deleteSigningPartyFieldAsync(signingPartyFieldId: number) {
    await axios.delete(`${ConfigurationUrl}signingpartyfield/${signingPartyFieldId}`);
  },
  async getTemplateSigningPartyFieldPlacementConfigurationAsync(
    templateSigningPartyFieldPlacementSearchModel: ScriveTemplateSigningPartyFieldPlacementSearchModel
  ): Promise<ScriveTemplateSigningPartyFieldPlacementModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(
      `${ConfigurationUrl}signingpartyfieldplacement/configuration`,
      {
        params: {
          templateSigningPartyFieldPlacementId:
            templateSigningPartyFieldPlacementSearchModel.templateSigningPartyFieldPlacementId
        }
      }
    );
    return response.data;
  },
  async createSigningPartyFieldPlacementAsync(
    templateSigningPartyFieldCreateUpdatePlacementModel: ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.post(
      `${ConfigurationUrl}signingpartyfieldplacement`,
      templateSigningPartyFieldCreateUpdatePlacementModel
    );
    return response.data;
  },
  async updateSigningPartyFieldPlacementAsync(
    signingPartyFieldPlacementId: number,
    templateSigningPartyFieldCreateUpdatePlacementModel: ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.put(
      `${ConfigurationUrl}signingpartyfieldplacement/${signingPartyFieldPlacementId}`,
      templateSigningPartyFieldCreateUpdatePlacementModel
    );
    return response.data;
  },
  async deleteSigningPartyFieldPlacementAsync(signingPartyFieldPlacementId: number) {
    await axios.delete(`${ConfigurationUrl}signingpartyfieldplacement/${signingPartyFieldPlacementId}`);
  },
  async getSettingsConfigurationAsync(documentTypeId?: number): Promise<ScriveSettingsConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ConfigurationUrl}settings`, {
      params: {
        documentTypeId
      }
    });
    return response.data;
  },
  async addUpdateSettingsConfigurationAsync(documentTypeId: number, settings: ScriveSettingsModel) {
    await axios.post(`${ConfigurationUrl}settings/${documentTypeId}`, settings);
  },
  async getTemplatesAfterSignConfigurationAsync(): Promise<ArenaSignTemplateAfterSignSettingModel[]> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ConfigurationUrl}templateAfterSignSetting`);
    return response.data;
  },
  async getTemplateAfterSignConfigurationAsync(id: number): Promise<ArenaSignTemplateAfterSignConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(
      `${ConfigurationUrl}templateAfterSignSetting/${id}`
    );
    return response.data;
  },
  async updateTemplateAfterSignSettingAsync(
    arenaSignTemplateAfterSignSettingUpdateModel: ArenaSignTemplateAfterSignSettingUpdateModel
  ): Promise<BaseResultModel> {
    const response = await axios.put(
      `${ConfigurationUrl}templateAfterSignSetting`,
      arenaSignTemplateAfterSignSettingUpdateModel
    );
    return response.data;
  }
};
